import { removeCustomActivityFormHTMLStyles } from "PFApp/activities/activity_form/hooks/use_set_html_styles";
import { LS_KEY_ENGAGEMENT_SCOPE_NEW_ACTIVITY_URL } from "PFApp/constants/local_storage_keys";
import { useOnPageExit } from "PFCore/hooks/use_on_page_exit";

const isActivityFormRoute = (pathname: string): boolean => {
  // /activities/:id/edit
  const isEditRoute = /^\/activities\/[^/]+\/edit$/;

  // /activities/:type/new
  const isNewRoute = /^\/activities\/[^/]+\/new$/;

  // /activities/:type/new/:id
  const isCloneRoute = /^\/activities\/[^/]+\/new\/[^/]+$/;

  return isEditRoute.test(pathname) || isNewRoute.test(pathname) || isCloneRoute.test(pathname);
};

export const useCleanupOnActivityFormExit = () => {
  const onActivityFormExit = () => {
    localStorage.removeItem(LS_KEY_ENGAGEMENT_SCOPE_NEW_ACTIVITY_URL);
    removeCustomActivityFormHTMLStyles();
  };

  useOnPageExit(isActivityFormRoute, onActivityFormExit);
};
